import React from "react";
import styled from "styled-components";
import { RiCopyrightLine } from "react-icons/ri";
import logo from "../../Images/logo.png";

const Footer = () => (
  <Container>
    <Content>
      <div className="footerTitle">
        <img src={logo} alt="" />
      </div>
      <div className="footerContents">
        타코벨 | 대표: 고수
        <br />
        사업자등록번호:123-45-567788 | 통신판매업신고번호:제 2020-서울강남-1145
        호
        <br />
        서울특별시 선릉로 위워크타워 10층
        <br />
        대표번호:010-3725-7637
      </div>
      <div className="footerEndWrap">
        <div>
          <RiCopyrightLine />
          타코벨 All rights reserved.
        </div>
        <div className="footerEnd">
          <div>이용약관</div>
          <div>개인정보처리방침</div>
        </div>
      </div>
    </Content>
  </Container>
);

export default Footer;

const Container = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const Content = styled.div`
  max-width: 1200px;
  height: 250px;
  margin: 0 auto;
  padding: 40px 25px 0 25px;
  background-color: white;
  font-size: 10px;
  color: grey;
  .footerTitle {
    img {
      width: 55px;
    }
  }
  .footerContents {
    margin-top: 20px;
    line-height: 21px;
  }
  .footerEndWrap {
    display: flex;
    margin-top: 20px;
    margin-left: auto;
    .footerEnd {
      display: flex;
      margin-left: auto;
      div {
        margin-right: 6px;
      }
    }
  }
`;
